import { useQuery, UseQueryResult } from 'react-query'
import { fetchRebookingHistory } from '../../services/RebookingService'

export interface RebookingHistoryResponse {
  status: string
  type: string
  requestorUser: string
  validatorUser: string
  validatedDateTime: string
  declineReasonCode: string
  declineReasonOther: string
  responsiblePartyCode: string
  reasonCode: string
  iDPPlannedTimestamp: string
  plannedDeliveryFromTime: string
  plannedDeliveryToTime: string
  shipToCode: string
  addressLine1Text: string
  addressLine2Text: string
  addressLine3Text: string
  zipCode: string
  cityName: string
  deliveryInstructionText: string
  alignedWithCarrierIndicator: string
  expectedMonthOfDelivery: string
  creationDateTime: string
  originalIdpPlannedTimestamp: string
  originalPlannedDeliveryFromTime: string
  originalPlannedDeliveryToTime: string
}

export const useRebookingHistory = (
  shipmentReference
): UseQueryResult<RebookingHistoryResponse[], any> => {
  return useQuery(
    ['rebookingHistory', shipmentReference],
    () => fetchRebookingHistory(shipmentReference),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )
}
